module.exports = __webpack_public_path__ + "static/img/menu1-img2.e469adeb.png";